import RestaurantLogo from './RestaurantLogo';
import connectContainer from './RestaurantLogoContainer';

export default connectContainer(RestaurantLogo);
